import TileGrid from './TileGrid'

export default TileGrid
// eslint-disable-next-line import/export
export * from './TileGrid'
